module.exports = __webpack_public_path__ + "img/freediving-2.ed780779.jpeg";